/* unplugin-vue-components disabled */import { render } from "./prompt-block.vue?vue&type=template&id=0c7971e4&scoped=true"
import script from "./prompt-block.vue?vue&type=script&lang=js"
export * from "./prompt-block.vue?vue&type=script&lang=js"

import "./prompt-block.vue?vue&type=style&index=0&id=0c7971e4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7971e4"],['__file',"src/pages/playground/prompt-block.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c7971e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c7971e4', __exports__)) {
    api.reload('0c7971e4', __exports__)
  }
  
  module.hot.accept("./prompt-block.vue?vue&type=template&id=0c7971e4&scoped=true", () => {
    api.rerender('0c7971e4', render)
  })

}


export default __exports__